import { DI } from '@intigral/constant/config/DIContainer';
import { Container } from '../../../DIContainer';
import GetChannelHistoryUseCase from './GetChannelHistoryUseCase';
import GetProfileWatchesHistoryUseCase from './GetProfileWatchesHistoryUseCase';
import GetSeriesHistoryUseCase from './GetSeriesHistoryUseCase';

export const initializeChannelSeriesUseCase = (container: Container) => {
    container.register(DI.USECASES.IGetChannelHistoryUseCase, {
        useClass: GetChannelHistoryUseCase,
    });
    container.register(DI.USECASES.IGetProfileWatchesHistoryUseCase, {
        useClass: GetProfileWatchesHistoryUseCase,
    });
    container.register(DI.USECASES.IGetSeriesHistoryUseCase, {
        useClass: GetSeriesHistoryUseCase,
    });
};
